import Vue from 'vue'
import utils from './index'

/**
 * This function accepts any type of value and reduces it to a single
 * string. This is particularly useful for translating objects with
 * nested values into a string.
 **/
function toMessageString(data) {
  if (typeof data === 'string' || typeof data === 'number') {
    return String(data)
  } else if (data instanceof Array) {
    return data.map(i => String(i)).join(', ')
  } else if (data instanceof Object) {
    let message = ''
    for (var key in data) {
      message += key + ': ' + toMessageString(data[key]) + '\n'
    }
    return message
  }
}

/**
 * A generic handler for API Errors.
 *
 * Shows Alert.alert notification for response error codes.
 *
 * @param
 **/
export function apiErrorHandler({ apiName = '', enable400Alert = true, Alert = null }) {
  return error => {
    const { response } = error

    // Console log for dev debug
    utils.debug(`${apiName} Error:`, error)

    if (!response) {
      throw error
    }

    // Show error to user
    if (response.status >= 400 && response.status < 500) {
      // Handle 4xx errors (probably bad user input)
      const { data } = response
      let message = ''

      // Handle common error structures
      if (data.detail) {
        message += `${data.detail}\n`
      } else if (data.non_field_errors) {
        message += `${data.non_field_errors}\n`
      } else {
        message = toMessageString(data)
      }

      if (enable400Alert && Alert) {
        Alert.alert('', message)
      }

      // Re-raise for further optional error handling
      throw error
    }

    // Generic handling for other errors (ex: 500 errors)
    if (Alert) {
      Alert.alert('', "Hmm, that didn't work. Try again later.")
    }

    // Re-raise for further optional error handling
    throw error
  }
}

/**
 * A generic error message that can be called within catch statements to
 * show client-side errors.
 **/

export function errorMessage() {
  Vue.prototype.$Alert.alert({
    type: 'error',
    message: '<p>There was an error. Check your connection and try again.</p>',
    timeout: 3000,
  })
}
